/**
 * LIFF 進入點還原純函式（無副作用，可單元測）：依 URL 參數判斷是否需在 Router 掛載前先還原路徑。
 * 呼叫端（index.js 薄殼）負責實際執行 history.replace(target)。
 *
 * @param {string} pathname - window.location.pathname
 * @param {string} search   - window.location.search（含 '?' 前綴）
 * @returns {string|null}   需要導轉的目標路徑，或 null（不干預）
 */
export default function computeLiffEntryRedirect(pathname, search) {
    const params = new URLSearchParams(search);

    // OAuth 回調（code）交給 liff.init 處理，不干預
    if (params.get('code')) return null;

    /**
     * in-client 深連結還原：使用者在 LINE App 內點了帶路徑的連結時，若 LIFF 後台設定的
     * endpoint URL 是網站根目錄（而非該路徑本身），LINE 會把原始路徑塞進 liff.state 這個
     * query 參數傳進來，所以這裡要取出並還原成真正要導向的路徑。
     */
    const liffState = params.get('liff.state');
    if (liffState) {
        return liffState;
    }

    // 防禦：綁定 token 落在根路徑，導去 /auth 交給 AuthPage 處理
    const t = params.get('t');
    if (pathname === '/' && t) {
        return `/auth?t=${encodeURIComponent(t)}`;
    }

    return null;
}
